import moment from "moment";
import { fetchToken } from "../APIEndPoints/EndPoints";
import { Decrypt, Encrypt } from "../Cryptography/Crypto";
import { HttpMethod } from "./APICalls";
import { EncryptedRequestModel } from "../../Models/EncryptedRequestModel";
import { EncryptedResponseModel } from "../../Models/EncryptedResponseModel";
import { enableEncryption } from "../Constants/Constants";

export interface TokenApiResponse {
  AccessToken: string;
  RefreshToken: string;
  Expiration: string;
}

let isFetchingToken = false;
let isFetchingTokenResolve, IsFetchingTokenReject;
let promiseIsFetchingToken;
export const fetchAuthToken = async (
  force = false
) => {
  if (isFetchingToken) {
    promiseIsFetchingToken = () =>
      new Promise((resolve, reject) => {
        isFetchingTokenResolve = resolve;
        IsFetchingTokenReject = reject;
      });
    await promiseIsFetchingToken();
  }
  isFetchingToken = true;
  let token = null;
  try {
    const offTokenObj = localStorage.getItem("pload1");
    if (!force && offTokenObj) {
      const offTokenObjDec = Decrypt(offTokenObj);
      if (offTokenObjDec) {
        const offTokenObjDecObj = JSON.parse(
          offTokenObjDec
        ) as TokenApiResponse;
        if (offTokenObjDecObj.AccessToken && offTokenObjDecObj.Expiration) {
          const expirationDate = moment.utc(
            offTokenObjDecObj.Expiration,
            "YYYY-MM-DDTHH:mm:ssZ"
          );
          const currDate = moment.utc().add(-1, "minutes");
          if (currDate.isSameOrAfter(expirationDate)) {
            //token is about to expire or is already expired
          } else {
            isFetchingToken = false;
            if (isFetchingTokenResolve) isFetchingTokenResolve();
            return offTokenObjDecObj.AccessToken;
          }
        }
      }
    }
  } catch (err) {}

  const inputParam = {
    username: process.env.REACT_APP_CRYPTO_OAUTH_KEY,
    password: process.env.REACT_APP_CRYPTO_OAUTH_PW,
  };

  let bodyData: any;
  if (enableEncryption) {
    let EncyptedRequestBody = Encrypt(JSON.stringify(inputParam));
    bodyData = JSON.stringify({
      RequestBody: EncyptedRequestBody,
    } as EncryptedRequestModel);
  } else {
    bodyData = JSON.stringify(inputParam);
  }

  let response = await fetch(fetchToken, {
    method: HttpMethod.POST,
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Access-Control-Allow-Headers": "*",
      // Authorization: "Bearer " + userAuthToken,
    },
    body: bodyData,
  });

  if (response.status < 300) {
    let responseBody = null;
    responseBody = await response.json();
    if (enableEncryption) {
      let newResponseBody = responseBody as EncryptedResponseModel;
      let DecyptedRequestBody = Decrypt(newResponseBody.Data);
      responseBody = JSON.parse(DecyptedRequestBody) as TokenApiResponse;
    }

    if (responseBody.AccessToken) {
      let pload1 = Encrypt(JSON.stringify(responseBody));
      localStorage.setItem("pload1", pload1);
      token = responseBody.AccessToken;
    }
  }
  isFetchingToken = false;
  if (isFetchingTokenResolve) isFetchingTokenResolve();

  return token;
};

